import Vue from 'vue'
import Router from 'vue-router'


const Manage = () => import(/* webpackChunkName: "Manage" */ '@/view/home/manage') //挂载主页面
const index = () => import(/* webpackChunkName: "Index" */ '@/view/index/index') // 概况页面
const organization = () => import(/* webpackChunkName: "organization" */ '@/view/index/organization') //组织切换页面

const Login = () => import(/* webpackChunkName: "Login" */ '@/view/login/login')//登录
const registered = () => import(/* webpackChunkName: "registered" */ '@/view/registered/registered')//注册
const ForgotPassword = () => import(/* webpackChunkName: "ForgotPassword" */ '@/view/registered/ForgotPassword')//修改密码
const verification = () => import(/* webpackChunkName: "verification" */ '@/view/verification/verification')//防伪码
const scanCode = () => import(/* webpackChunkName: "scanCode" */ '@/view/verification/scanCode')//扫码
const verifications = () => import(/* webpackChunkName: "verifications" */ '@/view/verification/verifications')//防伪码
//产品管理
// const productList = () => import(/* webpackChunkName: "productList" */'@/view/product/productList') //产品列表
// const templateMarket = () => import(/* webpackChunkName: "templateMarket" */'@/view/product/templateMarket') //模板市场
// const PrdTraceability = () => import(/* webpackChunkName: "PrdTraceability" */'@/view/product/PrdTraceability')
const addProduct = () => import(/* webpackChunkName: "addProduct" */'@/view/product/add/addProduct')//新增产品工作台
// const addPrdTraceability = () => import(/* webpackChunkName: "addPrdTraceability" */'@/view/product/add/addPrdTraceability')//新增产品
// const productDetails = () => import(/* webpackChunkName: "productDetails" */'@/view/product/details/productDetails')//产品详情
// const PrdTraceabilityDetails = () => import(/* webpackChunkName: "PrdTraceabilityDetails" */'@/view/product/details/PrdTraceabilityDetails')

// 发码管理
// const securityCode = () => import(/* webpackChunkName: "securityCode" */'@/view/Sending/securityCode')
// const addSecurityCode = () => import(/* webpackChunkName: "addSecurityCode" */'@/view/Sending/add/addSecurityCode')
// const securityDetails = () => import(/* webpackChunkName: "securityDetails" */'@/view/Sending/details/securityDetails')
// const codeTest = () => import(/* webpackChunkName: "codeTest" */'@/view/Sending/codeTest')
// const codeDiscard = () => import(/* webpackChunkName: "codeDiscard" */'@/view/Sending/codeDiscard')
// const logisticsCode = () => import(/* webpackChunkName: "logisticsCode" */'@/view/Sending/logisticsCode')
// const addLogisticsCode = () => import(/* webpackChunkName: "addLogisticsCode" */'@/view/Sending/add/addLogisticsCode')
// const logisticsDetails = () => import(/* webpackChunkName: "logisticsDetails" */'@/view/Sending/details/logisticsDetails')

//仓储管理
// const warehouse = () => import(/* webpackChunkName: "warehouse" */'@/view/Warehouse/warehouse') //仓库管理列表
// const addWarehouse = () => import(/* webpackChunkName: "addWarehouse" */'@/view/Warehouse/add/addWarehouse') //新增仓库管理
// const warehouseDetails = () => import(/* webpackChunkName: "warehouseDetails" */'@/view/Warehouse/details/warehouseDetails')//仓库管理详情
// const StoreView = () => import(/* webpackChunkName: "StoreView" */'@/view/Warehouse/StoreView')// 仓储总览
// const Putstorage = () => import(/* webpackChunkName: "Putstorage" */'@/view/Warehouse/Putstorage')// 产品入库
// const addPutstorage = () => import(/* webpackChunkName: "addPutstorage" */'@/view/Warehouse/add/addPutstorage')//入库新增
// const Outstorage = () => import(/* webpackChunkName: "Outstorage" */'@/view/Warehouse/Outstorage')// 产品出库
// const addOutstorage = () => import(/* webpackChunkName: "addOutstorage" */'@/view/Warehouse/add/addOutstorage')//出库新增
// const OutstorageDetails = () => import(/* webpackChunkName: "OutstorageDetails" */'@/view/Warehouse/details/OutstorageDetails') //出库详情
// const transfers = () => import(/* webpackChunkName: "transfers" */'@/view/Warehouse/transfers')//仓库调拨
// const addtransfers = () => import(/* webpackChunkName: "addtransfers" */'@/view/Warehouse/add/addtransfers')//新增仓库调拨
// const transfersDetails = () => import(/* webpackChunkName: "transfersDetails" */'@/view/Warehouse/details/transfersDetails')//仓库调拨详情
// const inventory = () => import(/* webpackChunkName: "inventory" */ '@/view/Warehouse/inventory')//库存盘点
// const addInventory = () => import(/* webpackChunkName: "addInventory" */'@/view/Warehouse/add/addInventory') //新增库存盘点
// const inventoryDetails = () => import(/* webpackChunkName: "inventoryDetails" */'@/view/Warehouse/details/inventoryDetails') //库存盘点详情
// const OutOrPut = () => import(/* webpackChunkName: "OutOrPut" */'@/view/Warehouse/OutOrPut')//出入库明细
// const OutOrPutDetails = () => import(/* webpackChunkName: "OutOrPutDetails" */'@/view/Warehouse/details/OutOrPutDetails')//出入库明细详情
// const infrastructure = () => import(/* webpackChunkName: "infrastructure" */'@/view/Warehouse/infrastructure') //基础设置

//采购管理

// const supplier = () => import(/* webpackChunkName: "supplier" */'@/view/procurement/supplier') //供应商管理
// const addSupplier = () => import(/* webpackChunkName: "addSupplier" */'@/view/procurement/add/addSupplier')//添加供应商管理
// const supply = () => import(/* webpackChunkName: "supply" */'@/view/procurement/details/supply')//供货管理
// const purchaseOrder = () => import(/* webpackChunkName: "purchaseOrder" */'@/view/procurement/purchaseOrder')//采购订单
// const addpurchaseOrder = () => import(/* webpackChunkName: "addpurchaseOrder" */'@/view/procurement/add/addpurchaseOrder')//新增采购订单
// const purOrderDetails = () => import(/* webpackChunkName: "purOrderDetails" */'@/view/procurement/details/purOrderDetails') //供货管理详情
// const purchaseRreturn = () => import(/* webpackChunkName: "purchaseRreturn" */'@/view/procurement/purchaseRreturn')//采购退货
// const addPurchaseRreturn = () => import(/* webpackChunkName: "addPurchaseRreturn" */'@/view/procurement/add/addPurchaseRreturn')//新增采购退货
// const PurchaseReturnDetails = () => import(/* webpackChunkName: "PurchaseReturnDetails" */'@/view/procurement/details/PurchaseReturnDetails')//采购退货详情
// const purchaseCompany = () => import(/* webpackChunkName: "purchaseCompany" */'@/view/procurement/purchaseCompany')//采购总汇

//账号管理

// const Account = () => import(/* webpackChunkName: "Account" */ '@/view/userInfo/Account')
// const billingDetails = () => import(/* webpackChunkName: "billingDetails" */'@/view/userInfo/details/billingDetails')
// const Information = () => import(/* webpackChunkName: "Information" */'@/view/userInfo/Information')
// const Members = () => import(/* webpackChunkName: "Members" */'@/view/userInfo/Members')
const pay = () => import(/* webpackChunkName: "pay" */'@/view/userInfo/pay')
// const choice = () => import(/* webpackChunkName: "choice" */'@/view/userInfo/choice')
// const renZheng = () => import(/* webpackChunkName: "renZheng" */'@/view/userInfo/add/renZheng')

//企业管理

// const dealerList = () => import(/* webpackChunkName: "dealerList" */'@/view/merchant/dealerList')
// const goodsManager = () => import(/* webpackChunkName: "goodsManager" */'@/view/merchant/goodsManager')
// const addDealer = () => import(/* webpackChunkName: "addDealer" */'@/view/merchant/add/addDealer')
// const dealerDetails = () => import(/* webpackChunkName: "dealerDetails" */'@/view/merchant/details/dealerDetails')
// const fleeingGoodsWarning = () => import(/* webpackChunkName: "fleeingGoodsWarning" */'@/view/logistics/fleeingGoodsWarning')
// const shipmentList = () => import(/* webpackChunkName: "shipmentList" */'@/view/logistics/shipmentList')
// const returnRecord = () => import(/* webpackChunkName: "returnRecord" */'@/view/logistics/returnRecord')
// const returnOrder = () => import(/* webpackChunkName: "returnOrder" */'@/view/logistics/add/returnOrder')
// const shipOrder = () => import(/* webpackChunkName: "shipOrder" */'@/view/logistics/add/shipOrder')
// const returnDetails = () => import(/* webpackChunkName: "returnDetails" */'@/view/logistics/details/returnDetails')
// import shipmentRecord from '@/view/logistics/shipmentRecord'
// import shopList from '@/view/merchant/shopList'
// import addShopList from '@/view/merchant/add/addShopList'
// import shopDetails from '@/view/merchant/details/shopDetails'
// import orderAudit from '@/view/merchant/orderAudit'
// import topUp from '@/view/merchant/add/topUp'
// import bill from '@/view/merchant/add/bill'
// import refund from '@/view/merchant/add/refund'
// import auditDetails from '@/view/merchant/details/auditDetails'
//import scanList from '@/view/merchant/scanList'
//物流管理
// import pdaList from '@/view/logistics/pdaList'
// import addPda from '@/view/logistics/add/addPda'
// import pdaDetails from '@/view/logistics/details/pdaDetails'


//公众号管理
// import classifyList from '@/view/publicPlatform/classifyList'
// import addClassify from '@/view/publicPlatform/add/addClassify'
// import classifyDetails from '@/view/publicPlatform/details/classifyDetails'
// import helpList from '@/view/publicPlatform/helpList'
// import addHelpText from '@/view/publicPlatform/add/addHelpText'
// import helpDetails from '@/view/publicPlatform/details/helpDetails'
// import feedbackList from '@/view/publicPlatform/feedbackList'
// import articleList from '@/view/publicPlatform/articleList'
// import addArticle from '@/view/publicPlatform/add/addArticle'
// import articleDetails from '@/view/publicPlatform/details/articleDetails'
// import feedbackDetails from '@/view/publicPlatform/details/feedbackDetails'
// import commentList from '@/view/publicPlatform/commentList'

//系统管理
// import roleList from '@/view/system/roleList'
// import userList from '@/view/system/userList'

// import addRole from '@/view/system/add/addRole'
// import addUser from '@/view/system/add/addUser'
// import roleDetails from '@/view/system/details/roleDetails'
// import userDetails from '@/view/system/details/userDetails'
// import productFieldDetails from '@/view/system/details/productFieldDetails'
// import editPassword from '@/view/system/add/editPassword'
// import newField from '@/view/system/add/newField'
// import addUserCustomer from '@/view/system/add/addUserCustomer'
// import userCustomer from '@/view/system/userCustomer'
// import productField from '@/view/system/productField'
// import merchantDetails from '@/view/system/details/merchantDetails'

//促销管理

// const onProduct = () => import(/* webpackChunkName: "onProduct" */'@/view/Salesmanag/onProduct')
// const shopOrder = () => import(/* webpackChunkName: "shopOrder" */'@/view/Salesmanag/shopOrder')
// const afterSales = () => import(/* webpackChunkName: "afterSales" */'@/view/Salesmanag/afterSales')
// const shopOrderDetails = () => import(/* webpackChunkName: "shopOrderDetails" */'@/view/Salesmanag/details/shopOrderDetails')
// const afterSalesDetails = () => import(/* webpackChunkName: "afterSalesDetails" */ '@/view/Salesmanag/details/afterSalesDetails')
// import envelope from '@/view/Salesmanag/envelope'
// import withdrawal from '@/view/Salesmanag/withdrawal'
// import changetype from '@/view/Salesmanag/changetype'
// import forrecord from '@/view/Salesmanag/forrecord'
// import coupontype from '@/view/Salesmanag/coupontype'
// import couponcollec from '@/view/Salesmanag/couponcollec'
// import integral from '@/view/Salesmanag/integral'
// import addForrecord from '@/view/Salesmanag/details/addForrecord'
// import forrDetails from '@/view/Salesmanag/details/forrDetails'
// import addChangeType from '@/view/Salesmanag/add/addChangeType'
// import addCouType from '@/view/Salesmanag/add/addCouType'
// import couTypeDetails from '@/view/Salesmanag/details/couTypeDetails'
// import changetypeDetail from '@/view/Salesmanag/details/changetypeDetail'

//营销管理 article

// const article = () => import(/* webpackChunkName: "article" */'@/view/marketing/article')
// const addArticle = () => import(/* webpackChunkName: "addArticle" */'@/view/marketing/add/addArticle')
// const articleDetails = () => import(/* webpackChunkName: "articleDetails" */'@/view/marketing/details/articleDetails')
// 会员
// const memberInfo = () => import(/* webpackChunkName: "memberInfo" */'@/view/member/memberInfo')
// const memberDetails = () => import(/* webpackChunkName: "memberDetails" */'@/view/member/details/memberDetails')

// 数据统计模块
// const queryChart = () => import(/* webpackChunkName: "queryChart" */'@/view/dataStatistics/queryChart')
// const scanList = () => import(/* webpackChunkName: "scanList" */'@/view/merchant/scanList')
// const scanListDetails = () => import(/* webpackChunkName: "scanListDetails" */'@/view/merchant/details/scanListDetails')
// const checkSalesRecord = () => import(/* webpackChunkName: "checkSalesRecord" */'@/view/merchant/checkSalesRecord')
// const shipment = () => import(/* webpackChunkName: "shipment" */'@/view/dataStatistics/shipment')
// const sendCodeData = () => import(/* webpackChunkName: "sendCodeData" */'@/view/dataStatistics/sendCodeData')
// const fleeGoods = () => import(/* webpackChunkName: "fleeGoods" */'@/view/dataStatistics/fleeGoods')
// import codeSend from '@/view/dataStatistics/codeSend'
// import codeType from '@/view/dataStatistics/codeType'
// import returnGood from '@/view/dataStatistics/returnGood'
// import returnRate from '@/view/dataStatistics/returnRate'
// import memberActivity from '@/view/dataStatistics/memberActivity'
// import areaActivity from '@/view/dataStatistics/areaActivity'


// 高级设置
// const key = () => import(/* webpackChunkName: "key" */ '@/view/set/key')
// const FeatureSet = () => import(/* webpackChunkName: "FeatureSet" */'@/view/set/FeatureSet')

// 企业使用协议
// const protocol = () => import(/* webpackChunkName: "protocol" */'@/view/protocol/protocol')
const NotFound = () => import(/* webpackChunkName: "NotFound" */'@/view/errorPage/404')

// const addProtocol = () => import(/* webpackChunkName: "addProtocol" */'@/view/protocol/add/addProtocol')
// import protocolDetails from '@/view/protocol/details/protocolDetails'

// 404、401

// const Unauthorized = () => import(/* webpackChunkName: "Unauthorized" */'@/view/errorPage/401')

// import addenvelope from '@/view/Salesmanag/add/addenvelope'

// 中间件
const publics = () => import('@/components/publics')
const welcome = () => import('@/components/welcome')

Vue.use(Router)
//路由配置项
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: Manage,
      hidden: true,
      children: [
        {
          path: '/welcome',
          component: welcome,
          name: 'welcome'
        }
      ]
    },
    {
      path: '/publics',
      name: 'publics',
      component: publics,
      hidden: true,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      hidden: true,
    },
    {
      path: '/registered',
      name: 'registered',
      component: registered,
      hidden: true,
    },
    {
      path: '/ForgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword,
      hidden: true,
    },
    {
      path: '/organization',
      name: 'organization',
      component: organization,
      hidden: true,
    },
    {
      path: '/verification',
      name: 'verification',
      component: verification,
      hidden: true,
    },
    {
      path: '/verifications',
      name: 'verifications',
      component: verifications,
      hidden: true,
    },
    {
      path: '/scancode',
      name: 'scanCode',
      component: scanCode,
      hidden: true,
    },
    {
      path: '/pay',
      component: pay,
      name: '订单支付',
      hidden: true
    },
    {
      path: '/addProduct',
      component: addProduct,
      name: '新增产品',
      hidden: true
    },
    {
      path: '/addProduct',
      component: addProduct,
      name: '编辑产品',
      hidden: true
    },
    {
      path: '*',
      name: 'Page404',
      component: NotFound,
      hidden: true,
    },

  ]
})

// 路由守卫
router.beforeEach((to, form, next) => {
  // 判断之前是否有登录过

  let loginTime = (Date.parse(new Date()) - localStorage.startTime) / 1000
  if (loginTime > 604800) {
    localStorage.clear()
  }
  const isLogin = localStorage.userToken ? true : false; //判断有没登陆
  let data = JSON.parse(window.sessionStorage.getItem('user'))
  if (data && to.path === '/login') {
    let curl = location.href
    if (curl.indexOf("zzx-test") != -1) {
      window.location.href = 'http://www.ky200.com/zzx-test/index.html'
      console.log("zzx-test")
    } else if (curl.indexOf("zzx") != -1) {
      window.location.href = 'http://www.ky200.com/zzx/index.html'
      console.log("zzx")
    } else {
      window.location.href = '/'
      console.log('/')
    }
    return false
  }
  // 判断cooike是否有信息
  // 除了login、registered、ForgotPassword、verification其他页面需要token才能进入，
  if (to.path == "/login" || to.path == '/registered' || to.path == '/ForgotPassword' || to.path == '/verifications' || to.path == '/verification' || to.path == '/scancode') {
    next();
  } else if (to.path == "/" || to.path == "/choice") {
    //时间大于7天清空所以,返回登录页
    if (loginTime > 604800) {
      localStorage.clear()
      sessionStorage.clear()
    }
    if (localStorage.userToken) {
      sessionStorage.userIf = localStorage.userIf
      if (to.path == "/") {
        // 跳转至概况页面
        next('/index');
      } else if (to.path == "/choice") {
        // 跳转至套餐页面
        next();
      }
    } else {
      // 没有cookie，第一次进入系统
      next('/login');
    }
  } else {
    isLogin ? next() : next('/login');
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js